module.exports = __webpack_public_path__ + "static/media/stockhausen_wolf_3.92c927e2.jpg";